import React from 'react';
import PropTypes from 'prop-types';

import { onColor, FONT_MONO } from '../constants/tokens';

/**
 * The full-bleed takeover shown when the school status escalates.
 *
 * This one deliberately does not use the shared Modal. Everything else in the
 * app is a card on a scrim; this is the screen going the colour of the alert,
 * because it has to be unmissable from across a room. It keeps the v7 type
 * scale but none of its restraint.
 */
export default function StatusAlertModal({ isVisible, alertStatus, dismissAlert }) {
  if (!isVisible || alertStatus == null) return null;

  const background = alertStatus.getColor().main;
  const ink = onColor(background);
  const soft = onColor(background, true);

  return (
    <div
      role='alertdialog'
      aria-label={alertStatus.getDashboardStatus() + ' alert'}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        background: background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 40,
        padding: 32,
        textAlign: 'center'
      }}
    >
      <div>
        <div
          style={{
            fontFamily: FONT_MONO,
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '20px',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: soft
          }}
        >
          School status
        </div>
        <div
          style={{
            fontSize: 'clamp(48px, 12vw, 120px)',
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: '-0.04em',
            textTransform: 'uppercase',
            color: ink,
            marginTop: 12
          }}
        >
          {alertStatus.getDashboardStatus()}
        </div>
      </div>

      <button
        type='button'
        onClick={dismissAlert}
        autoFocus
        style={{
          fontFamily: 'inherit',
          fontSize: 16,
          fontWeight: 600,
          lineHeight: '24px',
          minWidth: 200,
          height: 56,
          padding: '0 40px',
          borderRadius: 6,
          border: '2px solid ' + ink,
          background: 'transparent',
          color: ink,
          cursor: 'pointer'
        }}
      >
        Acknowledge
      </button>
    </div>
  );
}

StatusAlertModal.propTypes = {
  isVisible: PropTypes.bool,
  alertStatus: PropTypes.object,
  dismissAlert: PropTypes.func
};
